import { render } from "./HeaderSection.vue?vue&type=template&id=fbe35176&scoped=true"
import script from "./HeaderSection.vue?vue&type=script&lang=js"
export * from "./HeaderSection.vue?vue&type=script&lang=js"

import "./HeaderSection.vue?vue&type=style&index=0&id=fbe35176&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbe35176"]])

export default __exports__